import React from 'react';
import styled from '@emotion/styled';

interface IconProps {
  backgroundColor?: string;
  color?: string;
}

const StyledSvg = styled.svg`
  display: inline-block;
  vertical-align: middle;
`;

const CloseIcon: React.FC<IconProps> = ({
  backgroundColor = '#7B8794',
  color = 'white',
}) => {
  return (
    <StyledSvg
      width="36"
      height="36"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
        fill={backgroundColor}
      />
      <path
        d="M24 12L12 24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L24 24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSvg>
  );
};

export default CloseIcon;
